"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  px2rem: true
};
exports.px2rem = exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
Object.keys(_styledComponents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _styledComponents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _styledComponents[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/*
eslint-disable no-param-reassign, no-else-return, no-shadow, no-return-assign, no-use-before-define
*/

/* https://github.com/win-winFE/styled-px2rem */

var pxRe = /-?\d*[.\d]*px/g;
var base64Re = /^data:\w+\/[a-zA-Z+\-.]+;base64,/i;
var baseValue = 13;
var px2rem = exports.px2rem = function px2rem(px) {
  return Number(px) ? "".concat(Math.round(Number(px) / baseValue * 100000) / 100000, "rem") : 0;
};
var convertStringPx2rem = function convertStringPx2rem(style) {
  if (!style) return style;
  if (!base64Re.test(style) // 非base64字符串
  && pxRe.test(style) // 包含px单位
  ) {
    return style.replace(pxRe, function (value) {
      return px2rem(value.replace('px', ''));
    });
  }
  return style;
};
var convertInterpolationPx2rem = function convertInterpolationPx2rem(interpolation) {
  if (Object.prototype.toString.call(interpolation) === '[object Object]' && interpolation.constructor.name.toLowerCase() === 'keyframes') {
    interpolation.rules = interpolation.rules.map(convertStringPx2rem);
    return interpolation;
  }
  if (Object.prototype.toString.call(interpolation) === '[object Array]') {
    return convertStringPx2rem(interpolation.join(''));
  } else if (typeof interpolation !== 'function') {
    return interpolation;
  }
  return function (props) {
    var result = interpolation(props);
    if (typeof result === 'string') {
      return convertStringPx2rem(result);
    }
    if (Array.isArray(result)) {
      return result.map(convertInterpolationPx2rem);
    }
    return result;
  };
};
var withCss = function withCss(styled) {
  var interleave = function interleave(strings) {
    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }
    strings = strings.map(convertStringPx2rem);
    interpolations = interpolations.map(convertInterpolationPx2rem);
    return styled.apply(void 0, [strings].concat((0, _toConsumableArray2["default"])(interpolations)));
  };
  Object.keys(styled).forEach(function (prop) {
    return interleave[prop] = withTemplateFunc(styled[prop]);
  });
  return interleave;
};
var withTemplateFunc = function withTemplateFunc(styled) {
  return function () {
    return withCss(styled.apply(void 0, arguments));
  };
};
var styledPx2rem = function (styled) {
  var obj = withTemplateFunc(styled);
  Object.keys(styled).forEach(function (key) {
    obj[key] = withCss(styled[key]);
    Object.keys(styled[key]).forEach(function (prop) {
      return obj[key][prop] = withTemplateFunc(styled[key][prop]);
    });
  });
  return obj;
}(_styledComponents["default"]);
var _default = exports["default"] = styledPx2rem;